import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ReturnDownloadLabelEmailRenderer } from "./email";
import type { ReturnDownloadLabelBlockProps } from "./types";

export function ReturnDownloadLabelEditorRenderer(
  props: ReturnDownloadLabelBlockProps,
) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <div className="[&_a]:pointer-events-none [&_a]:cursor-default">
        <ReturnDownloadLabelEmailRenderer isEditor {...props} />
      </div>
    </EmailComponentWrapper>
  );
}
